import { ClienteAnaliseMercadoFilter } from '../../adapters';

export class ClienteAnaliseMercadoFilterStorage {
    filter: ClienteAnaliseMercadoFilter;
    filterValues: Map<string, any>;

    constructor(filter: ClienteAnaliseMercadoFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
